<div class="p-6 bg-gray-50 min-h-screen">
  <!-- Page Header -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 pb-4 border-b border-gray-200">
    <div class="flex items-center gap-3">
      <div class="w-11 h-11 bg-gradient-to-tr from-teal-600 to-emerald-400 rounded-xl flex items-center justify-center text-white shadow-md shadow-teal-200">
        <i class="fas fa-users text-xl"></i>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-900 tracking-tight">Customer Collections</h1>
        <p class="text-sm text-gray-500">Customers who completed a scrap collection in a date range, exported as an Excel file</p>
      </div>
    </div>
  </div>

  <!-- Filters Panel -->
  <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
    <div class="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-4">
      <!-- Date Presets -->
      <div class="flex flex-wrap items-center gap-1.5">
        <span class="text-xs font-semibold uppercase text-gray-400 mr-2 tracking-wider">Date Range:</span>
        <button *ngFor="let p of presets" (click)="selectPreset(p.id)"
          [class.bg-green-600]="selectedPreset === p.id"
          [class.text-white]="selectedPreset === p.id"
          [class.bg-gray-100]="selectedPreset !== p.id"
          [class.text-gray-700]="selectedPreset !== p.id"
          [class.hover:bg-gray-200]="selectedPreset !== p.id"
          class="px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all flex items-center gap-1.5">
          <i class="fas {{ p.icon }} text-xs" [class.text-white]="selectedPreset === p.id" [class.text-gray-400]="selectedPreset !== p.id"></i>
          {{ p.label }}
        </button>
      </div>

      <!-- Custom Dates & Zone Filter -->
      <div class="flex flex-wrap items-center gap-3">
        <div *ngIf="selectedPreset === 'custom'" class="flex items-center gap-2">
          <app-date-input [(ngModel)]="fromDate" placeholder="From"></app-date-input>
          <app-date-input [(ngModel)]="toDate" placeholder="To"></app-date-input>
        </div>

        <div class="min-w-[200px]">
          <app-district-zone-filter [(ngModel)]="selectedZoneIds"></app-district-zone-filter>
        </div>

        <button (click)="generate()" [disabled]="generating"
          class="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg text-sm font-medium shadow-sm transition-all">
          <i class="fas fa-spinner fa-spin mr-2" *ngIf="generating"></i>
          <i class="fas fa-file-excel mr-2" *ngIf="!generating"></i>
          Generate
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg mb-6">
    <div class="flex items-center">
      <i class="fas fa-exclamation-circle text-red-500 mr-3"></i>
      <p class="text-sm text-red-700">{{ errorMessage }}</p>
    </div>
  </div>

  <div class="bg-white rounded-xl shadow-sm border border-gray-200">
    <div class="px-4 py-3 border-b border-gray-200">
      <h2 class="text-sm font-semibold text-gray-700">Recent reports</h2>
    </div>

    <div *ngIf="loadingHistory" class="px-4 py-6 text-sm text-gray-500 text-center">
      <i class="fas fa-spinner fa-spin mr-1"></i> Loading…
    </div>

    <div *ngIf="!loadingHistory && recentJobs.length === 0" class="px-4 py-6 text-sm text-gray-500 text-center">
      No reports generated yet.
    </div>

    <div *ngFor="let job of recentJobs" class="px-4 py-3 border-b border-gray-100 last:border-b-0 flex items-center justify-between gap-4">
      <div class="text-sm text-gray-700">
        <div class="flex items-center flex-wrap gap-x-2">
          <span class="font-medium">{{ job.fromDate | date:'MMM d, y' }} – {{ job.toDate | date:'MMM d, y' }}</span>

          <span *ngIf="job.status === Status.Pending || job.status === Status.Running" class="text-gray-500">
            <i class="fas fa-spinner fa-spin mr-1"></i>{{ job.statusMessage || 'Running' }}…
          </span>

          <span *ngIf="job.status === Status.Completed" class="text-green-600">
            <i class="fas fa-check-circle mr-1"></i>{{ job.rowCount }} customer{{ job.rowCount === 1 ? '' : 's' }}
          </span>

          <span *ngIf="job.status === Status.Failed" class="text-red-600">
            <i class="fas fa-exclamation-circle mr-1"></i>
            Failed{{ job.statusMessage ? ': ' + job.statusMessage : '' }}
          </span>

          <span *ngIf="job.status === Status.Expired" class="text-gray-500">
            <i class="fas fa-clock mr-1"></i>Expired
          </span>
        </div>
        <div class="text-xs text-gray-400 mt-0.5">Generated {{ job.createdAt | date:'MMM d, y, h:mm a' }}</div>
      </div>

      <a *ngIf="job.status === Status.Completed" [href]="job.downloadUrl" target="_blank" [title]="job.fileName"
        class="bg-green-600 hover:bg-green-700 text-white text-xs font-semibold px-3 py-1.5 rounded-md whitespace-nowrap">
        <i class="fas fa-download mr-1"></i> Download
      </a>
    </div>
  </div>
</div>
